/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCatalogCategoryRequest
 */
export interface UpdateCatalogCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogCategoryRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCatalogCategoryRequest
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCatalogCategoryRequest
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the UpdateCatalogCategoryRequest interface.
 */
export function instanceOfUpdateCatalogCategoryRequest(value: object): value is UpdateCatalogCategoryRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateCatalogCategoryRequestFromJSON(json: any): UpdateCatalogCategoryRequest {
    return UpdateCatalogCategoryRequestFromJSONTyped(json, false);
}

export function UpdateCatalogCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCatalogCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'enabled': json['enabled'],
    };
}

export function UpdateCatalogCategoryRequestToJSON(json: any): UpdateCatalogCategoryRequest {
    return UpdateCatalogCategoryRequestToJSONTyped(json, false);
}

export function UpdateCatalogCategoryRequestToJSONTyped(value?: UpdateCatalogCategoryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'enabled': value['enabled'],
    };
}

